export const BASE_URLS = {
  SESSIONS: '/api/analytics/admin/sessions',
  UTILIZATION: '/api/analytics/admin/utilization',
  USERS: '/api/analytics/admin/utilization/users',
  WELLNESS: '/api/analytics/admin/wellness',
  SELF_SESSIONS: '/api/analytics/sessions',
} as const;

export const CACHE_TIMES = {
  STALE_TIME: 5 * 60 * 1000, // 5 minutes
  GC_TIME: 30 * 60 * 1000, // 30 minutes
  USER_SEARCH_STALE_TIME: 2 * 60 * 1000, // 2 minutes for user search
  PREFETCH_DELAY: 500, // 500ms
  DASHBOARD_STALE_TIME: 10 * 60 * 1000, // 10 minutes for dashboard aggregates
} as const;

export const DEFAULT_QUERY_OPTIONS = {
  retry: 2,
  refetchOnWindowFocus: false,
  refetchOnReconnect: 'always' as const,
  structuralSharing: true,
} as const;

export const DEFAULTS = {
  USER_SEARCH_LIMIT: 10,
  TOP_EXPERIENCES_LIMIT: 50,
  USER_RANKINGS_LIMIT: 5,
  DEBOUNCE_MS: 300,
} as const;
